import { useMemo } from 'react';
import type { InteractiveMapMarker } from 'components/InteractiveMap';
import { findNearestValue } from 'helper/Meteorology/Agro/Maps/geoUtils';
import type { WBSequentialMapData } from 'types/Meteorology/Agro/WaterBalanceSequential/Maps/getMapData';

export default function useEnrichedMarkers(
  markers: InteractiveMapMarker[] | undefined,
  mapData: WBSequentialMapData | undefined,
  variableLabel: string,
  unit: string,
): InteractiveMapMarker[] | undefined {
  return useMemo(() => {
    if (!markers) return undefined;
    if (!mapData?.length || !variableLabel) return markers;

    return markers.map((m) => {
      const [lat, lng] = m.position;
      const value = findNearestValue(lat, lng, mapData);
      const tooltipExtra = value !== null
        ? { label: variableLabel, value: String(value), unit }
        : undefined;
      return { ...m, tooltipExtra };
    });
  }, [markers, mapData, variableLabel, unit]);
}
